import { ThemeProvider } from "@mui/material/styles";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import Cookies from "js-cookie";
import { useState } from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.scss";
import { theme } from "./assets/styles/Common/MUITheme";
import { useAppSelector } from "./hooks/reduxhooks";
import RouteConfig from "./navigation/RouteConfig";
import ScrollToTop from "./utils/ScrollToTop";
import LoadingCircles from "./components/LoadingCircles/LoadingCircles";
import { reactPlugin } from "./ApplicationInsights";
import SessionTimeout from "./components/SessionTimeout/SessionTimeout";
import CookieModal from "./components/CookieModal/CookieModal";
import useWebChat from "./hooks/WebChat/useWebChat";

function App() {
  useWebChat({
    widgetId: process.env.REACT_APP_WEBCHAT_WIDGET_ID ?? "",
    snippetId: process.env.REACT_APP_WEBCHAT_SNIPPET_ID ?? "",
    iconType: "CHAT",
    openChatColor: "#ffffff",
    openChatBackgroundColor: "#004470",
    closeChatColor: "#ffffff",
    closeChatBackgroundColor: "#004470",
  });

  const isAuthed = useAppSelector((state) => state.userSlice.isAuthenticated);
  const [modalOpen, setModalOpen] = useState(() => {
    const cookiesAcknowledged = Cookies.get("google-consent-confirmed");
    if (cookiesAcknowledged) {
      return false;
    }
    return true;
  });
  const isLoading = useAppSelector(
    (state) => state.ClaimSlice.loadingData.loading
  );
  const handleModalClose = () => {
    setModalOpen(false);
  };

  return (
    <div className="App">
      <AppInsightsContext.Provider value={reactPlugin}>
        <ThemeProvider theme={theme}>
          {/* if not authed then dont show cookie banner */}
          {isAuthed && (
            <>
              <CookieModal isOpen={modalOpen} onClose={handleModalClose} />
              <SessionTimeout />
            </>
          )}

          <BrowserRouter>
            {isLoading && <LoadingCircles isLoading={isLoading} />}
            <ScrollToTop />
            <RouteConfig />
          </BrowserRouter>
        </ThemeProvider>
      </AppInsightsContext.Provider>
    </div>
  );
}

export default App;
